<div class="annual-plan-dialog-form-phase">
    <form [formGroup]="macrocycleForm">
        <h1 mat-dialog-title>
            {{ data.dialogTitle | translate}}
        </h1>
        <div mat-dialog-content>
            <fieldset [disabled]="isSubmitting">

                <div class="line line-margin">
                    <div fxLayout="row" fxLayoutAlign="space-around center" >
                        <div>
                            <mat-form-field>
                                <mat-select placeholder="{{ 'WeekFrom' | translate }}" [compareWith]="compareWeekMenus" formControlName="weekFrom">
                                    <mat-option *ngFor="let menuFrom of weeksMenuFrom" [value]="menuFrom" [disabled]="menuFrom.isDisabled" (onSelectionChange)="updateWeeksMenuTo($event, menuFrom.number)">
                                        {{ menuFrom.realNumber ? menuFrom.realNumber + ' (' + menuFrom.realWeekYear + ')' : menuFrom.number }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="f['weekFrom'].errors && f['weekFrom'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                                <mat-error *ngIf="f['weekFrom'].errors && f['weekFrom'].hasError('lessThanNumber')">{{ 'Field_less_than_end' | translate }}</mat-error>
                            </mat-form-field>

                        </div>
                        <div>
                            <mat-form-field color="primary">
                                <mat-select placeholder="{{ 'WeekTo' | translate }}" [compareWith]="compareWeekMenus" formControlName="weekTo">
                                    <mat-option *ngFor="let menuTo of weeksMenuTo" [value]="menuTo" [disabled]="menuTo.isDisabled" >
                                        {{ menuTo.realNumber ? menuTo.realNumber + ' (' + menuTo.realWeekYear + ')' : menuTo.number }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="f['weekTo'].errors && f['weekTo'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                                <mat-error *ngIf="f['weekTo'].errors && f['weekTo'].hasError('greaterThanNumber')">{{ 'Field_more_than_start' | translate }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="line">
                    <mat-form-field color="primary">
                        <mat-select placeholder="{{ 'Macrocycle' | translate }}" [compareWith]="compareMacroCycles" formControlName="macrocycle">
                            <mat-option *ngFor="let macroCycle of macroCycles" [value]="macroCycle">
                                <span class="category-color" [style.background-color]="macroCycle.hexadecimalColor"></span>&nbsp;{{ macroCycle.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </fieldset>
        </div>
        <mat-dialog-actions>

            <button mat-button mat-dialog-close tabindex="-1">
                {{ 'Cancel' | translate}}
            </button>

            <button *ngIf="data.annualPlanMacroCycle" mat-button color="warn" tabindex="-1" (click)="onDelete()">{{ 'Delete' | translate }}</button>

            <button mat-raised-button (click)="submitForm()" color="accent">
                {{ 'Validate' | translate}}
            </button>

        </mat-dialog-actions>
    </form>
</div>
